import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
import FormatQuoteIcon from '@material-ui/icons/FormatQuote';
import FeedbacksContext from '../contexts/FeedbacksContext';
import Reveal from './Reveal';
import { colors } from '../theme';

const useStyles = makeStyles((theme) => ({
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    padding: theme.spacing(4),
    boxShadow: '0 8px 30px rgba(14,35,64,0.08)',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(3),
    },
  },
  quoteIcon: {
    fontSize: 44,
    color: colors.gold,
    marginLeft: -6,
  },
  text: {
    flexGrow: 1,
    color: theme.palette.text.primary,
    fontSize: '1.02rem',
    whiteSpace: 'pre-line',
    margin: theme.spacing(1, 0, 3),
  },
  name: {
    fontFamily: theme.typography.h6.fontFamily,
    fontWeight: 700,
    color: colors.navy,
  },
}));

// Reviews the owner approved in the admin page, skipping any with no text.
export function approvedReviews(feedbacks) {
  return feedbacks.filter((item) => item.show && item.feedback && item.feedback.trim());
}

// True once reviews have loaded and at least one is approved.
export function useHasReviews() {
  const context = useContext(FeedbacksContext);
  if (!context || !context.feedbacksLoaded) return false;
  return approvedReviews(context.feedbacks).length > 0;
}

export default function FeedbacksList() {
  const classes = useStyles();
  const { feedbacks } = useContext(FeedbacksContext);
  const approved = approvedReviews(feedbacks);

  if (approved.length === 0) return null;

  return (
    <Grid container spacing={3}>
      {approved.map((item, index) => (
        <Grid item xs={12} sm={6} md={4} key={item.id || index}>
          <Reveal delay={(index % 3) * 100}>
            <figure className={classes.card} style={{ margin: 0 }}>
              <FormatQuoteIcon className={classes.quoteIcon} aria-hidden="true" />
              <blockquote className={classes.text} style={{ marginLeft: 0, marginRight: 0 }}>
                {item.feedback}
              </blockquote>
              {item.feedbackName && (
                <figcaption className={classes.name}>— {item.feedbackName}</figcaption>
              )}
            </figure>
          </Reveal>
        </Grid>
      ))}
    </Grid>
  );
}
